export default "__VITE_ASSET__C0WtG2Kw__"